import { Controller } from "@hotwired/stimulus"

// Reordena filas arrastrándolas y guarda el orden nuevo en el servidor.
//
//   <div data-controller="sortable" data-sortable-url-value="/backoffice/proyectos/ordenar">
//     <tr data-sortable-target="row" data-id="7"
//         data-action="dragstart->sortable#start dragover->sortable#over drop->sortable#drop dragend->sortable#end">
//       <td><span data-sortable-handle data-action="mousedown->sortable#grab">⠿</span></td>
//
// Solo se arrastra desde el asa (⠿): así el resto de la fila sigue siendo texto
// seleccionable y los enlaces de "Editar" / "Borrar" no se pelean con el arrastre.
export default class extends Controller {
  static targets = ["row", "status"]
  static values = { url: String }

  grab(event) {
    const row = event.currentTarget.closest("[data-sortable-target='row']")
    if (row) row.draggable = true
  }

  start(event) {
    this.dragging = event.currentTarget
    this.orderBefore = this.ids().join()
    this.dragging.classList.add("opacity-40")
    event.dataTransfer.effectAllowed = "move"
    // Firefox no arranca el arrastre si no se escribe algo en dataTransfer.
    event.dataTransfer.setData("text/plain", this.dragging.dataset.id)
  }

  over(event) {
    if (!this.dragging) return
    event.preventDefault()
    event.dataTransfer.dropEffect = "move"

    const target = event.currentTarget
    if (target === this.dragging) return

    // Se cuela por encima o por debajo según en qué mitad de la fila estemos.
    const rect = target.getBoundingClientRect()
    const below = event.clientY > rect.top + rect.height / 2
    target.parentNode.insertBefore(this.dragging, below ? target.nextSibling : target)
  }

  // Sin esto Firefox interpreta el texto soltado como una navegación.
  drop(event) {
    event.preventDefault()
    this.end()
  }

  end() {
    if (!this.dragging) return
    this.dragging.classList.remove("opacity-40")
    this.dragging.draggable = false
    this.dragging = null

    if (this.ids().join() !== this.orderBefore) this.save()
  }

  ids() {
    return this.rowTargets.map((row) => row.dataset.id)
  }

  async save() {
    try {
      const response = await fetch(this.urlValue, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "X-CSRF-Token": document.querySelector("meta[name=csrf-token]")?.content
        },
        body: JSON.stringify({ ids: this.ids() })
      })
      this.flash(response.ok ? "Orden guardado" : "No se pudo guardar el orden", response.ok)
    } catch {
      this.flash("No se pudo guardar el orden", false)
    }
  }

  flash(message, ok) {
    if (!this.hasStatusTarget) return
    this.statusTarget.textContent = message
    this.statusTarget.classList.toggle("text-danger", !ok)
    this.statusTarget.classList.remove("opacity-0")
    clearTimeout(this.timer)
    this.timer = setTimeout(() => this.statusTarget.classList.add("opacity-0"), 2000)
  }
}
